import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class TruncateText extends ThemeComponent {
    @Ref() truncateButton!: HTMLButtonElement[];

    init() {
        if (this.truncateButton) {
            for( const button of this.truncateButton) {
                this.$listen(button, 'click', () => {
                    if (this.classList.contains('truncate-text--expanded')) {
                        this.classList.remove('truncate-text--expanded');
                    } else {
                        this.classList.add('truncate-text--expanded');
                    }
                });
            }
        }
    }

}
